import {
  Grid,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../Menu";
import {
  changeActiveSchool,
  rehydrateNavData,
} from "../../../redux/navmode.action";
import noImageAvailable from "assets/images/no-image-available.png";
import { setSchoolParams } from "./HeaderContent";
import { useHistory, useLocation } from "react-router-dom";

interface ISchoolDropdownFilter {
  Status: string;
  UserId?: number;
}

const useStyles = makeStyles({
  schoolTitle: {
    color: "#2B3674",
    marginLeft: 8,
    fontSize: "24px",
    fontWeight: 600,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  expandIcon: {
    marginLeft: 8,
    color: "#2B3674",
  },
  schoolDropdown: {
    display: "flex",
    alignItems: "center",
  },
  schoolImage: {
    width: "25px",
    objectFit: "cover",
    height: "25px",
    borderRadius: "30px",
  },
});

const SchoolSelection = () => {
  const classes = useStyles();
  const provider = useDataProvider();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [anchorEl, setAnchorEl] = useState(null);
  const [schools, setSchools] = useState([]);

  const navMode = useSelector((state: AppState) => state.navMode);
  const roles: string[] = localStorage.getItem("roles")
    ? localStorage.getItem("roles").split(",")
    : [];

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOptionSelect = (option: any) => {
    dispatch(changeActiveSchool(option));
    setSchoolParams(option.id, history, location);
    handleMenuClose();
  };

  const getSchools = () => {
    const rolesFiltered = [
      "admin",
      "operation",
      "customerservice",
      "finance",
      "school",
    ];
    let filter: ISchoolDropdownFilter = { Status: "active" };

    if (roles.some((role) => rolesFiltered.includes(role))) {
      filter = {
        UserId: Number(localStorage.getItem("userId")),
        Status: "active",
      };
    }

    provider
      .getList("schools", {
        filter: filter,
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Name",
          order: "ASC",
        },
      })
      .then((result: any) => {
        setSchools(result.data);
      })
      .catch(() => {
        setSchools([]);
      });
  };

  useEffect(() => {
    getSchools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(rehydrateNavData());
    if (navMode.school === null) {
      if (schools.length > 0) {
        dispatch(changeActiveSchool(schools[0]));
        setSchoolParams(schools[0].id, history, location);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schools]);

  return (
    <>
      <Grid item className={classes.schoolDropdown} onClick={handleMenuOpen}>
        {navMode.school !== null ? (
          <>
            <img
              className={classes.schoolImage}
              src={
                navMode.school?.photoUrl === null
                  ? noImageAvailable
                  : navMode.school?.photoUrl
              }
              alt={`${navMode.school?.name} logo`}
            />
            <Typography variant="subtitle1" className={classes.schoolTitle}>
              {navMode.school?.name}
            </Typography>
          </>
        ) : (
          <></>
        )}

        <IconButton size="small" className={classes.expandIcon}>
          <ExpandMoreIcon />
        </IconButton>
      </Grid>

      <Menu
        id="dropdown-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {schools.map((school, index) => (
          <MenuItem key={index} onClick={() => handleOptionSelect(school)}>
            <img
              className={classes.schoolImage}
              src={
                school.photoUrl === null ? noImageAvailable : school.photoUrl
              }
              alt={`${school.name} logo`}
            />
            <span style={{ marginLeft: 8 }}>{school.name}</span>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SchoolSelection;
